import _ from 'lodash'
import fp from 'lodash/fp'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import {
  KNOCK_TRACE_KEY,
  SEARCH_HISTORY_LOCAL_STORAGE_KEY,
  SERVICE_LOCATION_KEY,
  SNS_TYPE_LIST,
  MENU,
  MULTI_SECTION_LIST_ACTIONS,
  SET_CURRENT_GNB,
  SET_CURRENT_MENU,
} from '@/common/resources/const'
import { getEmergencyInfo, getUser, knock } from '@/common/utils/request'
import { parseUrl, stringify } from 'query-string'
import { autoLoginSetting } from '@/common/utils/login'
import { setReferer } from '@/common/utils/referer'
import store from '@/store'
import { isForceUpdate } from '@/common/utils/gnb.fp'

export const isFalsy = (val) => _.isNil(val) || val === ''
export const getGUID = () =>
  _.get(JSON.parse(localStorage.getItem('guid')), 'guid', '')
export const setGUID = (guid) => {
  localStorage.setItem('guid', JSON.stringify(guid))
}
export const setIp = (ip) => {
  localStorage.setItem('ip', ip)
}
export const getIp = () => localStorage.getItem('ip')
export const setUserID = (userID) => {
  localStorage.setItem('user-id', userID)
}
export const getUserID = () => {
  return localStorage.getItem('user-id')
}
export const addPostfix = (source, postfix) => {
  const isEmpty = isFalsy(source)
  if (isEmpty) return ''
  const ext = '.' + source.split('.').pop()
  const pattern = new RegExp('\\' + ext + '$', 'g')
  return source.replace(pattern, '_' + postfix + ext)
}
export const addPostfixAndUrl = (source, postfix) => {
  return hasProtocol(source)
    ? addPostfix(source, postfix)
    : window.location.protocol + '//' + addPostfix(source, postfix)
}
export const getDateFromTimeString = (timeString) => {
  const isNotTimeString = isFalsy(timeString)
  if (isNotTimeString) {
    return new Date()
  }
  const splitString = timeString.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
  return new Date(
    splitString[1],
    splitString[2] - 1,
    splitString[3],
    splitString[4],
    splitString[5],
  )
}
export const isStaging = () => {
  return true
}
export const getDrm = () => {
  let agent = navigator.userAgent.toLowerCase()
  let findAgent = 'none'
  // IE
  if (agent.indexOf('msie') !== -1 || agent.indexOf('trident') !== -1) {
    findAgent = 'wc'
  } else if (
    agent.indexOf('chrome') !== -1 ||
    agent.indexOf('firefox') !== -1
  ) {
    findAgent = 'wm'
  } else if (agent.indexOf('safari') !== -1) {
    findAgent = 'fp'
  }
  return findAgent
}
export const getUserInfo = () => {
  const userInfo = {
    credentialKey: encodeURIComponent(cookie.getCredential()),
    GUID: getGUID(),
    clientIP: getIp(),
    userNo: cookie.getUno(),
    userID: getUserID(),
    profileID: cookie.getProfileId(),
    pooqzoneType: cookie.getPooqZoneType(),
  }
  return getUser()
    .then(({ data }) => {
      userInfo.adultverification = _.get(data, 'adultverification', '')
      return userInfo
    })
    .catch(() => {
      return userInfo
    })
}
export const setDisableScrolling = (isEnable) => {
  document.body.style.position = isEnable ? 'fixed' : ''
  document.body.style.overflowY = isEnable ? 'scroll' : ''
  document.body.style.width = isEnable ? '100%' : ''
}
export const showRequiredLoginPopup = () => {
  if (cookie.getCredential() === 'none') {
    let confirmLogin = confirm(constant.MSG_NEED_FOR_MOVING_LOGIN)
    if (confirmLogin) {
      window.location.href =
        '/member/login.html?referer=' +
        encodeURIComponent(location.href.replace(location.origin, ''))
    }
    return true
  }
  return false
}

export const setReplaceAll = (content, word, changeWord) => {
  let specials = new RegExp('[.*+?|()\\[\\]{}\\\\]', 'g') // .*+?|()[]{}\
  let re = new RegExp(word.replace(specials, '\\$&'), 'g')
  if ((content && content.indexOf(word) >= 0) || typeof word === 'object') {
    content = content.replace(re, changeWord)
  }
  return content
}

export const isSnsLogin = () => {
  return SNS_TYPE_LIST.indexOf(cookie.userInfo('type') || '') > -1
}

export const showCoinPopup = ({ isAuto = false, returnUrl, isDcb = false }) => {
  const credential = cookie.getCredential()
  if (showRequiredLoginPopup()) return
  if (isSnsLogin()) {
    if (!confirm(constant.MSG_COIN_SNS_ALERT)) {
      return
    }
  }
  const popup = window.open(
    constant.URL_BILLING_PRODUCT_COIN +
      '?credential=' +
      encodeURIComponent(credential) +
      '&isAuto=' +
      (isAuto ? 1 : 0) +
      '&returnUrl=' +
      encodeURIComponent(returnUrl) +
      '&pgname=' +
      (isDcb ? 'skt_dcb' : '') +
      '&deviceTypeId=pc&marketTypeId=generic',
    '',
    'width=700, height=780, scrollbars=yes',
  )
  popup.focus()
}

export const showBillingCouponPopup = ({
  couponNumber,
  returnUrl,
  canceledUrl,
}) => {
  const credential = cookie.getCredential()
  if (showRequiredLoginPopup()) {
    return undefined
  }

  if (isSnsLogin()) {
    if (!confirm(constant.MSG_VOUCHER_SNS_ALERT)) {
      return undefined
    }
  }

  const popup = window.open(
    `${constant.URL_BILLING_PAYMENT_COUPON}?credential=${encodeURIComponent(credential)}&deviceTypeId=pc&couponSerialNumber=${couponNumber}&returnUrl=${encodeURIComponent(returnUrl)}&canceledUrl=${encodeURIComponent(canceledUrl)}`,
    `PaymentCouponWindow`,
    'width=700, height=780, scrollbars=yes',
  )

  popup?.focus()
}

export const showBillingPopup = ({
  productId,
  productType,
  returnUrl,
  contentType = '',
  contentId = '',
  promotionCode = '',
  canceledUrl,
}) => {
  const credential = cookie.getCredential()
  if (showRequiredLoginPopup()) return
  if (isSnsLogin()) {
    if (!confirm(constant.MSG_VOUCHER_SNS_ALERT)) {
      return
    }
  }

  window.voucherAutoLogin = function () {
    const credential = cookie.getCredential()
    const isMultiLine = Number(cookie.userInfo('profilecount')) !== 1
    autoLoginSetting(credential, isMultiLine).then((res) => {})
  }

  const popup = window.open(
    constant.URL_BILLING_PAYMENT +
      '?credential=' +
      encodeURIComponent(credential) +
      '&productId=' +
      encodeURIComponent(productId) +
      '&productType=' +
      productType +
      '&returnUrl=' +
      encodeURIComponent(returnUrl) +
      '&contentType=' +
      encodeURIComponent(contentType) +
      '&contentid=' +
      encodeURIComponent(contentId) +
      '&promotionCode=' +
      encodeURIComponent(promotionCode) +
      '&canceledUrl=' +
      encodeURIComponent(canceledUrl) +
      '&deviceTypeId=pc&marketTypeId=generic&partnerUserKey=',
    'PaymentWindow',
    'width=700, height=780, scrollbars=yes',
  )
  popup.focus()
}
export const setEnterChange = (content, changeWord = '<br>') => {
  return content.replace(/(?:\r\n|\r|\n)/g, changeWord)
}

export const isNumberCheck = (text) => {
  const regNumber = /^[0-9]*$/
  return regNumber.test(text)
}
export const getSecondToTime = (seconds) => {
  let playTime = ''
  let hour = Math.floor(seconds / 3600)
  let minute = Math.floor((seconds % 3600) / 60)
  let second = ''

  if (seconds < 60) {
    // 초 데이터
    if (seconds < 10) second = '00:' + '0' + seconds
    if (seconds > 10) second = '00:' + seconds

    playTime = second
  } else if (seconds < 3600) {
    // 분초 데이터
    second = seconds - minute * 60

    if (minute < 10) minute = '0' + minute
    if (second < 10) second = '0' + second

    playTime = minute + ':' + second
  } else {
    // 시분초 데이터
    second = seconds - hour * 3600 - minute * 60

    if (minute < 10) minute = '0' + minute
    if (second < 10) second = '0' + second

    playTime = hour + ':' + minute + ':' + second
  }
  return playTime
}

export const getTimeStamp = () => {
  let date = new Date()
  let requestTime = ''
  requestTime += date.getFullYear() + '-'
  requestTime += ('00' + (date.getMonth() + 1)).slice(-2) + '-'
  requestTime += ('00' + date.getDate()).slice(-2) + ' '
  requestTime += ('00' + date.getHours()).slice(-2) + ':'
  requestTime += ('00' + date.getMinutes()).slice(-2) + ':'
  requestTime += ('00' + date.getSeconds()).slice(-2)
  return requestTime + '+900'
}

export const getUnixTimeStamp = () => {
  return Math.floor(new Date().getTime() / 1000)
}

export const setSearchWordSave = (text) => {
  localStorage.setItem(
    SEARCH_HISTORY_LOCAL_STORAGE_KEY,
    fp.flow(
      fp.split('&'),
      fp.compact,
      fp.thru((list) => {
        list.unshift(text)
        return list
      }),
      fp.thru((list) => _.uniq(list)),
      fp.slice(0, 20),
      fp.join('&'),
    )(localStorage.getItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY)),
  )
}

export const clickLink = (url) => {
  if (url.startsWith('www.wavve.com')) {
    window.location.href = url.replace('www.wavve.com', '')
  } else if (url.startsWith('member.wavve.com')) {
    window.location.href = 'https://' + url
  } else {
    const hasProtocol = url.substring(0, 4) === 'http'
    window.open(hasProtocol ? url : 'https://' + url, '_blank')
  }
}

export const hasProtocol = (url) => url.substring(0, 4) === 'http'

export const bannerLink = (targetUrl) => {
  if (targetUrl.indexOf('captvpooq://purchasewebview') > -1) {
    const { query } = parseUrl(targetUrl)
    const locationOrign =
      window.location.protocol + '//' + window.location.hostname
    showBillingPopup({
      productId: query.productId,
      productType: 'all',
      returnUrl: constant.URL_PROTOCOL_WITH_DOMAIN,
      canceledUrl: locationOrign + '/callback.html?action=Cancel',
    })
  } else {
    const { url, query } = parseUrl(targetUrl)
    const hasWavveDomain = url.indexOf('wavve.com') > -1
    if (hasWavveDomain) {
      let newUrl = hasProtocol(url) ? url : prependProtocol(url)
      newUrl = newUrl.replace('http://', 'https://')
      newUrl =
        Object.keys(query).length > 0 ? newUrl + '?' + stringify(query) : newUrl
      location.assign(newUrl)
    } else {
      location.assign(hasProtocol(targetUrl) ? url : prependProtocol(targetUrl))
    }
  }
}

export const setNumberCommas = (number = '') => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export const prependProtocol = (url) => location.protocol + '//' + url

export const removeProtocolAndWavveDomain = (url) =>
  url.replace('https://www.wavve.com', '').replace('http://', '')

export const setLibFile = (d, s, id, url) => {
  let js
  let fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) {
    return
  }
  js = d.createElement(s)
  js.id = id
  js.src = url
  fjs.parentNode.insertBefore(js, fjs)
}

export const getResultCodeInResponse = (response) =>
  _.get(response, ['data', 'resultcode'], '')
export const getResultMessageInResponse = (response) =>
  _.get(response, ['data', 'resultmessage'], '')
export const needSelectProfile = (response) =>
  _.get(response, 'needselectprofile', 'n') === 'y'
export const getStatusInResponse = (response) => _.get(response, 'status', '')

export const isProductMode = process.env.NODE_ENV === 'production'

export const previewPlayableBrowser = () => {
  const { name, major } = window.uaInfo.getBrowser()
  return !(name.toUpperCase() === 'IE' && Number(major) < 11)
}

export const isPlayableCell = () => {
  const hasLogin = cookie.getCredential() !== 'none'
  return previewPlayableBrowser() && hasLogin
}

export const isPrerenderer = () => {
  return _.get(window, ['__PRERENDER_INJECTED', 'isPreRender'], '') === 'y'
}

export const currentProtocolEqualTo = (protocol) =>
  location.protocol === protocol

const MultiPlyRatio = 1.5
const THUMBNAIL = {
  LANDSCAPE: {
    width: 240,
    height: 135,
    placeholderImage: require('../../assets/images/common/img_default_thum_2.svg'),
    componentName: 'landscape-cell',
  },
  MY_VIEW_LANDSCAPE: {
    width: 302,
    height: 170,
    placeholderImage: require('../../assets/images/common/img_default_thum_2.svg'),
    componentName: 'landscape-cell',
  },
  PORTRAIT: {
    width: 240,
    height: 360,
    placeholderImage: require('../../assets/images/common/img_default_thum_1.svg'),
    componentName: 'portrait-cell',
  },
  PORTRAIT_RANKING: {
    width: 240,
    height: 360,
    placeholderImage: require('../../assets/images/common/img_default_thum_1.svg'),
    componentName: 'portrait-ranking-cell',
  },
  CIRCLE: {
    width: Math.round(160 * MultiPlyRatio),
    height: Math.round(160 * MultiPlyRatio),
    placeholderImage: require('../../assets/images/common/img_default_thum_3.svg'),
    componentName: 'circle-cell',
  },
  BASEBALL_LANDSCAPE: {
    width: Math.round(240 * MultiPlyRatio),
    height: Math.round(135 * MultiPlyRatio),
    componentName: 'baseball-landscape-cell',
    placeholderImage: require('../../assets/images/common/img_default_thum_2.svg'),
  },
  PREVIEW_INSTANT_PLAYER: {
    width: 407,
    height: 229,
    componentName: 'preview-instant-player-cell',
    placeholderImage: require('../../assets/images/common/img_default_thum_4.svg'),
  },
  EDITOR_PICK_PACKAGE: {
    width: Math.round(406 * MultiPlyRatio),
    height: Math.round(228 * MultiPlyRatio),
    componentName: 'editor-pick-package-cell',
    placeholderImage: require('../../assets/images/common/img_default_thum_1.svg'),
  },
  ERROR: {
    width: 0,
    height: 0,
    componentName: 'error',
    placeholderImage: '',
  },
}

export const getThumbnailInfo = (cellType) => {
  // const MultiPlyRatio = 1.5
  const res = {
    type: cellType,
    typeNumber: '',
    width: '',
    height: '',
  }

  const getThumbnailSet = (componentType) => {
    return Object.assign(res, componentType)
  }

  switch (cellType) {
    case 'band_1':
    case 'band_2':
    case 'band_3':
    case 'band_4':
    case 'band_5':
    case 'band_6':
    case 'band_7':
    case 'band_42':
      getThumbnailSet(THUMBNAIL.LANDSCAPE)
      break
    case 'band_myview':
      getThumbnailSet(THUMBNAIL.MY_VIEW_LANDSCAPE)
      break

    case 'band_52':
      getThumbnailSet(THUMBNAIL.LANDSCAPE)
      if (isPlayableCell()) res.componentName = 'landscape-player-cell'
      break

    case 'band_8':
    case 'band_9':
    case 'band_10':
    case 'band_11':
    case 'band_12':
    case 'band_13':
    case 'band_14':
    case 'band_61':
    case 'band_95':
    case 'band_96':
    case 'band_97':
    case 'band_highlight':
      getThumbnailSet(THUMBNAIL.PORTRAIT)
      break

    case 'band_94':
    case 'band_98':
      getThumbnailSet(THUMBNAIL.PORTRAIT_RANKING)
      break

    case 'band_15':
    case 'band_16':
    case 'band_17':
    case 'band_18':
    case 'band_19':
    case 'band_20':
    case 'band_21':
      getThumbnailSet(THUMBNAIL.CIRCLE)
      break

    case 'band_43':
      getThumbnailSet(THUMBNAIL.BASEBALL_LANDSCAPE)
      break

    case 'band_82':
      getThumbnailSet(THUMBNAIL.PREVIEW_INSTANT_PLAYER)
      break

    case 'band_71':
      getThumbnailSet(THUMBNAIL.EDITOR_PICK_PACKAGE)
      break

    default:
      getThumbnailSet(THUMBNAIL.ERROR)
  }
  return res
}
export const commonErrorProcess = (error) => {
  if (error.response && error.response.status === 550) {
    let message = error.response.data.resultmessage
      ? error.response.data.resultmessage
      : '서버에서 알 수 없는 오류가 발생했습니다.'
    alert(message.replace('\\\\n', '\n').replace('\\n', '\n'))
  }
}
export const scrollTop = () => {
  window.scrollTo(0, 0)
}
export const scrollTopWithCallback = (callback) => {
  scrollTop()
  callback && callback()
}

export const scrollToElement = (selector) => {
  const el = document.querySelector(selector)
  if (el !== null) {
    let bodyRect = document.body.getBoundingClientRect()
    let elemRect = el.getBoundingClientRect()
    let offset = elemRect.top - bodyRect.top
    window.scrollTo(0, offset)
  }
}

const getReferer = () => {
  return cookie.getItem('referer-url') || document.referrer || '/index.html'
}

export const redirectToHttps = () => {
  if (isPrerenderer()) return
  if (window.location.protocol === 'http:') {
    console.log('redirectToHttps - http')
    let referer = getReferer()
    if (referer.indexOf('/adult.html') > -1) {
      referer = '/index.html'
    }
    setReferer(referer)
    const url = location.href.replace(location.protocol, 'https:')
    if (isProductMode) {
      location.replace(url)
      return false
    }
  }
}

export const allowDeviceCheck = () => {
  if (isPrerenderer()) return
  const deviceType = window.uaInfo.getDevice().type
  if (isProductMode) {
    if (deviceType === 'mobile' || deviceType === 'tablet') {
      location.replace(location.href.replace(location.hostname, 'm.wavve.com'))
    }
  }
}

export const pad = (num, width) => {
  let numStr = num + ''
  return numStr.length >= width
    ? numStr
    : new Array(width - numStr.length + 1).join('0') + numStr
}

export const logger = (color) => (text) => {
  const str = typeof text === 'object' ? JSON.stringify(text) : text
  console.log(`%c ${str}`, `background: #222; color:${color};font-size: 15px`)
}

export const changeReferer = (referer) => {
  return referer.replace(location.protocol + '//' + location.host, '')
}

export const replaceSpecialCharacters = (string) => {
  // eslint-disable-next-line
  const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
  return _.replace(string, regExp, '') // ?
}

export const replaceSpecialCharactersFilter = (string) => {
  // eslint-disable-next-line
  const regExp = /[\{\}\/?.,;:|\)*~`!^\_+@\#%&\\\\(\']/gi
  // const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\_+@\#%&\\\\(\']/gi
  return _.replace(string, regExp, '') // ?
}

export const isExplorer = () => {
  let agent = navigator.userAgent.toLowerCase()
  return agent.indexOf('msie') !== -1 || agent.indexOf('trident') !== -1
}

export const destroyPlayer = () => {
  window.playerInstance &&
    window.playerInstance.destructor &&
    window.playerInstance.destructor()
}

export const unloadPlayer = () => {
  window.playerInstance &&
    window.playerInstance.unload &&
    window.playerInstance.unload()
}

export const detachPlayerEvents = () => {
  window.playerInstance &&
    window.playerInstance.clearEvent &&
    window.playerInstance.clearEvent()
}

export const isIos13IPad = () => {
  const userAgent =
    navigator.userAgent.match(/Mac|MacIntel/) === null
      ? []
      : navigator.userAgent.match(/Mac|MacIntel/)
  return userAgent.length > 0 && navigator.maxTouchPoints > 2
}

// const isWavveDomain = location.hostname === 'www.wavve.com'
const isProduction = process.env.NODE_ENV === 'production'
const deviceType = window.uaInfo.getDevice().type
const isMobileDevice =
  deviceType === 'mobile' || deviceType === 'tablet' || isIos13IPad()
const toDomain = isMobileDevice ? 'm.wavve.com' : 'www.wavve.com'

export const asyncRedirectWithParam = () => {
  if (isPrerenderer()) return Promise.resolve()
  if (!isProduction) return Promise.resolve()
  return new Promise((resolve, reject) => {
    let toUrl = location.href
    if (location.hostname === 'wavve.com') {
      reject(
        toUrl
          .replace('www.wavve.com', toDomain)
          .replace(location.protocol, 'https:'),
      )
    } else if (location.hostname === 'www.wavve.com') {
      if (location.protocol === 'http:' || isMobileDevice) {
        reject(
          toUrl
            .replace(location.hostname, toDomain)
            .replace(location.protocol, 'https:'),
        )
      } else {
        resolve(true)
      }
    }
  })
  // if (isPrerenderer()) return
  // if (!isProduction) return
}

// export const isRootPath = location.pathname === '/' || location.pathname === '/index' || location.pathname === '/index.html'
// export const autoLoginTransfer = () => {
//   if (isPrerenderer()) return
//   const protocol = isProduction ? 'https://' : 'http://'
//   const savedUserId = cookie.getSaveUserId()
//   const savedCredential = cookie.getAutoLoginCredential() || 'none'
//   const isAutoLoginPath = location.pathname === '/autologin'
//   if (isPooqDomain && isRootPath) {
//     if (savedUserId !== 'none' || savedCredential !== 'none') {
//       let url = `${protocol}www.wavve.com/autologin?`
//       const queryParam = {}
//       if (savedUserId !== 'none') {
//         queryParam.userid = savedUserId
//         cookie.removeItem('userId', constant.URL_COOKIE_DOMAIN, '/')
//       }
//       if (savedCredential !== 'none') {
//         queryParam.key = `${decodeURIComponent(savedCredential).replace(/"/gi, '')}`
//         cookie.removeItem('cs', constant.URL_COOKIE_DOMAIN, '/')
//         cookie.removeItem('credential', constant.URL_COOKIE_DOMAIN, '/')
//       }
//       location.href = `${url}${stringify(queryParam)}`
//     } else {
//       location.href = 'https://www.wavve.com/index.html'
//     }
//   } else if (isWavveDomain && isAutoLoginPath) {
//     const { query } = parseUrl(location.href)
//     const userId = _.get(query, 'userid', '')
//     const credential = _.get(query, 'key', '')
//     try {
//       if (userId !== '') {
//         saveIdProcess({ saveId: true, userId })
//       }
//       if (credential !== '') {
//         setAutoLoginInfo({ autoLogin: true, credential })
//       }
//       location.href = `${protocol}www.wavve.com/index.html`
//     } catch (e) {
//       location.replace(`${protocol}www.wavve.com/index.html`)
//     }
//   } else {
//     console.log('redirectiWithParams')
//     redirectWithParam()
//   }
// }

export const removePrefixEmptyString = (string) => {
  const res = []
  const charList = string.split('')
  let removeComplete = false
  for (let i = 0, len = charList.length; i < len; i++) {
    if (charList[i] !== ' ') {
      removeComplete = true
    }
    if (removeComplete) {
      res.push(charList[i])
    }
  }
  return res.join('')
}

export const removeEmptySpace = (
  origin = '',
  options = { trim: true, start: true, middle: true, end: true },
) => {
  let result = options.trim ? origin.trim() : origin
  if (options.middle) {
    result = result.replace(/\s+/g, ' ')
    return result
  }
  if (options.start) {
    result = result.replace(/^\s*/, '')
  }
  if (options.end) {
    result = result.replace(/\s*$/, '')
  }
  return result
}

export const checkEmergency = () => {
  const emergencyPathList = ['/event/index', '/event/index.html']
  getEmergencyInfo().then(({ isEmergency, emergencyUrl }) => {
    const isEmergencyPath =
      emergencyPathList.filter((path) => path === location.pathname).length > 0
    if (isEmergency && !isEmergencyPath) {
      location.replace(emergencyUrl)
    }
  })
}

export const emergencyPlayerProc = ({ isEmergency, emergencyUrl }) => {
  if (!isEmergency) {
    alert('무료 시청이 종료되었습니다. \n' + '다른 콘텐츠를 이용해 주세요.')
    location.replace('/')
  }
  const { name } = window.uaInfo.getBrowser()
  if (name === 'IE') {
    alert(
      '지원되지 않는 브라우저를 사용하고 계시네요.\nIE edge, Chrome, Safari 및 Firefox로 이용해 주세요.',
    )
  } else {
    const { query } = parseUrl(emergencyUrl)
    const title = _.get(query, 'title', '이벤트')
    const channelId = _.get(query, 'channelid', 'C9232')
    const startTime = _.get(query, 'starttime', '16:30')
    window.open(
      location.protocol +
        '//' +
        `www.wavve.com/pooqplayer/popupPlayer.html?type=live&contentID=${channelId}&resolution=1080p&isAutoPlay=false&isDVR=false&query="playtype=z"&title=${title}&starttime=${startTime}`,
      'emergencyPopup',
      'status=no, titlebar=no, toolbar=no, width=880, height=495',
    )
  }
}

export function comparePath(orgPath, checkPath) {
  let isCorrect = false
  if (orgPath === checkPath) return true
  const orgPathList = orgPath.split('/')
  const checkPathList = checkPath.split('/')
  if (orgPathList.length === checkPathList.length) {
    let isMatched = true
    let i = 0
    while (i < checkPathList.length) {
      if (!isMatched) break
      const orgPath = orgPathList[i]
      const checkPath = checkPathList[i]
      if (orgPath !== '{path}') {
        isMatched = orgPath === checkPath
      }
      i = i + 1
    }
    isCorrect = isMatched
  }
  return isCorrect
}

export function changeEscapeCharacter(text) {
  return text.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>')
}

export function getContentDetailData(response) {
  const data = _.get(response, 'data', null)
  if (data === null) {
    alert('해당 데이터가 없습니다.')
    this.$router.back()
  }
  return data
}

export function hasUserConfirmPPV() {
  return cookie.isPpvConfirmUser()
}

// TODO: 로그인시 cookie cs로 저장할 값에 ppv 입장 여부가 들어가 있음 그 값으로 체크 할 수 있도록 수정하고, 현재는 임시
export function getUserConfirmPpvInfo() {
  // return localStorage.getItem('PPV_CONFIRM_YN')
}

export function customerSubMenuScrollEvent(
  stickyMenuEl,
  contentElList,
  subMenuElList,
  stickyMenuElInitOffset,
) {
  const scrollTop = window.pageYOffset
  scrollTop > stickyMenuElInitOffset
    ? stickyMenuEl.classList.add('sticky')
    : stickyMenuEl.classList.remove('sticky')
  let filteredEl = _.filter(
    contentElList,
    (contentEl) => scrollTop >= contentEl.offsetTop - 65,
  )
  const focusId = filteredEl.length === 0 ? 'i-sec01' : filteredEl.pop().id
  subMenuElList.forEach((menuEl) => {
    if (menuEl.getAttribute('href').replace('#', '') === focusId) {
      menuEl.classList.add('on')
    } else {
      menuEl.classList.remove('on')
    }
  })
}

export function getPromotionCodeFromUrl(url) {
  const { query } = parseUrl(url)
  const { referer } = query
  let promotionCode = _.get(query, 'promotioncode', '')
  if (promotionCode === '' && referer !== undefined && referer !== '') {
    const { query: refererQuery } = parseUrl(referer)
    promotionCode = _.get(refererQuery, 'promotioncode', '')
  }
  return promotionCode
}
export function loginRedirectUrl(targetUrl, promotionCode = '') {
  const { url, query } = parseUrl(targetUrl)
  if (promotionCode !== '') {
    query.promotioncode = promotionCode
  }
  return url + '?' + stringify(query)
}

export function sendKnock() {
  if (cookie.getItem(KNOCK_TRACE_KEY) === null) {
    knock().then(() => {
      cookie.setItem(KNOCK_TRACE_KEY, 'knock')
    })
  }
}
const changeGnbIfNeeded = (menuName) =>
  menuName === MENU.MOVIE && hasUserConfirmPPV() ? MENU.MOVIE_17 : menuName

export const beforeGNBEnter = (to, from, next) => {
  const toName = changeGnbIfNeeded(to.name)
  store.commit(SET_CURRENT_GNB, toName)
  if (to.name !== '') {
    store.commit(SET_CURRENT_MENU, toName)
  }
  next()
  const force = isForceUpdate(to.name)
  store
    .dispatch(MULTI_SECTION_LIST_ACTIONS.FETCH, { gnbName: toName, force })
    .then(() => {})
}
export const beforeEnterNeedAdultCheckPage = (to, from, next) => {
  if (
    from.name !== 'login' &&
    from.name !== 'profile_list' &&
    from.name !== 'adult'
  ) {
    setReferer(from.fullPath)
  }
  next()
}
export function titleTagNameChange(title) {
  document.getElementsByTagName('title')[0].innerHTML = title
}

/**
 * dev 도메인 여부
 * @returns {boolean}
 */
export const isDev = () => {
  const origin = location.origin
  return origin.indexOf('dev-') > -1
}

/**
 * qa 도메인 여부
 * @returns {boolean}
 */
export const isQA = () => {
  const origin = location.origin
  return origin.indexOf('qa-') > -1
}

/**
 * api, 플레이어 호출등에서 현재 도메인 dev, qa에 따라 프리픽스 붙이는 함수
 * @param domain
 * @returns {string}
 */
export const getDomainWithPrefix = (domain) => {
  if (!domain || typeof domain !== 'string') {
    return ''
  }
  if (isDev()) {
    return domain.replace(/(https?:\/\/)/, '$1dev-')
  }
  if (isQA()) {
    return domain.replace(/(https?:\/\/)/, '$1qa-')
  }
  return domain
}

/**
 * 현재 프로토콜 (http:, https:) 구분하여 리턴
 * @returns {https: | http:}
 */
export const getProtocol = () => {
  return location.protocol ? location.protocol : 'https:'
}

/**
 * body fade-out 처리 함수 (stream 이동용)
 */
export const setFadeOutBody = () => {
  return new Promise((resolve) => {
    document.body.classList.add('fade-out')
    setTimeout(() => {
      resolve()
    }, 700)
  })
}

export const removeFadeOutBody = () => {
  document.body.classList.remove('fade-out')
}

export const getDomainWithWordPrefix = (word = '', url = '') => {
  if (!word || !url || typeof url !== 'string') {
    return ''
  }
  return url.replace(/(https?:\/\/)/, `$1${word}-`)
}

/**
 * object의 nullish property를 제거합니다.
 * @param {object} origin
 * @returns {object} nullish property가 제거된 object
 */
export const removeNullishProperty = (origin) => {
  const result = {}
  if (origin) {
    for (let key in origin) {
      if (origin[key] !== null && origin[key] !== undefined) {
        result[key] = origin[key]
      }
    }
  }
  return result
}

export const sleep = (delay) =>
  new Promise((resolve) => setTimeout(resolve, delay))

/**
 * 배포된 환경에 대한 정보를 반환합니다.
 *
 * - `release` 브랜치, `stg` 브랜치: `prd`
 * - `qa` 브랜치: `qa`
 * - `dev` 브랜치, 그 외(로컬 환경 등): `dev`
 *
 * @returns {string} 환경 정보 (`dev` | `qa` | `prd`)
 */
export const getEnv = () => {
  const env = process.env.VUE_APP_COMMIT_BRANCH
  switch (env) {
    case 'release':
    case 'stg':
      return 'prd'
    case 'qa':
      return 'qa'
    default:
      return 'dev'
  }
}

/**
 * object의 property를 제거합니다.
 * @param {object} origin
 * @param {string[]} properties
 * @returns {object} properties에 해당하는 property를 제거한 object
 */
export const removeProperties = (origin, properties) => {
  const result = { ...origin }
  properties.forEach((property) => {
    delete result[property]
  })
  return result
}

/**
 * url에 query string을 추가합니다.
 * @param {string} url
 * @param {object} params
 * @returns string
 */
export const addQueryParams = (url, params) => {
  const urlObj = new URL(url)
  for (const [key, value] of Object.entries(params)) {
    urlObj.searchParams.set(key, value)
  }
  return urlObj.toString()
}
